(function HotelEngineMap($, Adzuki)
{
	'use strict';

	const component = {
		emits   : ['updated'],
		template: '#he-search-filters',
		data() {
			return {
				baseUri: Adzuki.base_uri,
			};
		},
		computed: {
			mapInfo() {
				return this.filteredHotels.map(hotel => ({
					lat    : hotel.lat,
					lng    : hotel.lng,
					title  : hotel.name,
					image  : hotel.metadata?.images?.[0]?.thumbnail_url || this.baseUri + '/images/map-back.png',
					address: hotel.full_address,
					price  : (hotel.best_value_pricing?.selling_price && hotel.best_value_pricing?.selling_price > 0) ? this.formatCurrency(hotel.best_value_pricing?.selling_price) : 'Hotel Unavailable'
				}));
			},
		},
		methods: {
			buildMapContent(property) {
				const content = document.createElement("div");
				content.className = 'marker-container';
				content.innerHTML = `
					<div class="price-marker" style="background-color: rgb(0, 51, 102); color: white; padding: 5px 10px; border-radius: 4px; font-weight: bold; display: inline-block; min-width: 40px; text-align: center;">${property.price}</div>
					<div class="marker-details hidden" style="width: 200px; background-color: #fff;">
						<img src="${property.image}" alt="${property.title}" style="width: 100%; height: 100px; object-fit: cover; border-radius: 4px;">
						<strong>${property.title}</strong>
						<br>
						<span>${property.address}</span>
						<span>${property.price}</span>
					</div>
					`;
				return content;
			},
			async getPoi() {
				try {
					const formData = new FormData();

					formData.append('lat', this.coordinates.lat);
					formData.append('lng', this.coordinates.lng);
					formData.append('radius', this.formData.locationRadius);

					const response = await fetch(this.baseUri + '/HotelEngine/vuePoi', {
						method: 'POST',
						body  : formData,
					});

					if (!response.ok) {
						throw new Error(`Error fetching details: ${response.statusText}`);
					}

					this.pointsOfInterest = await response.json();

				} catch (err) {
					console.error('Error fetching additional details:', err);
				}


			},
			initGoogleMap(divClass) {
				// Find the map container
				const mapContainer = document.querySelector('.'+divClass);

				if (!mapContainer) {
					console.error('Map container not found!');
					return;
				}

				// Parse markers from the data-map-markers attribute
				const markersData = JSON.parse(mapContainer.getAttribute('data-map-markers') || '[]');

				// Ensure there's at least one marker
				if (!markersData.length) {
					console.warn('No marker data available to render');
					return;
				}

				// Center the map on the first marker
				const centerCoordinates = {
					lat: parseFloat(markersData[0].lat),
					lng: parseFloat(markersData[0].lng),
				};

				// Initialize the Google Map
				const map = new google.maps.Map(mapContainer, {
					center: centerCoordinates,
					zoom  : 12,
					mapId : divClass,
				});

				// Add markers to the map
				markersData.forEach((markerInfo) => {
					let marker;
					if (markerInfo.lat && markerInfo.lng) {
						if (markerInfo.price) {
							marker = new google.maps.marker.AdvancedMarkerElement({
								position: {
									lat: parseFloat(markerInfo.lat),
									lng: parseFloat(markerInfo.lng)
								},
								content: this.buildContent(markerInfo),
								map,
								title  : markerInfo.title,
							});
						} else {
							marker = new google.maps.marker.AdvancedMarkerElement({
								position: {
									lat: parseFloat(markerInfo.lat),
									lng: parseFloat(markerInfo.lng)
								},
								map,
								title: markerInfo.title
							});
						}

						marker.addListener('gmp-click', () => {
							this.toggleMarker(marker);
						});
					}
				});
			},
			toggleMarker(marker) {
				const priceMarker   = marker.querySelector('.price-marker');
				const markerDetails = marker.querySelector('.marker-details');
				if (priceMarker.classList.contains('hidden')) {
					priceMarker.classList.remove('hidden');
					markerDetails.classList.add('hidden');
					marker.zIndex = null;
				} else {
					priceMarker.classList.add('hidden');
					markerDetails.classList.remove('hidden');
					marker.zIndex = 1;
				}
			}
		},
		watch: {
		},
	};

	Adzuki.VueComponents.HotelEngineMap = component;
}(jQuery, window.Adzuki || {}));
